import React, { useContext, useEffect, useState } from 'react';
import { Context } from "../contexts/AppContext";
import { useParams } from 'react-router-dom';
import UploadImageBg from '../Gallery/UploadImageBg';
import { putData } from '../../lib/utils';

const CompanySetting = () => {
  const { value } = useContext(Context);
  const [appState, setAppState] = value;
  const { galleryId } = useParams();
 
  const [companyName, setCompanyName] = useState('');
  const [phone, setPhone] = useState('');
const [address, setAddress] = useState('');
  const [websiteUrl, setWebsiteUrl] = useState('');
  const [youtube, setYoutube] = useState('');
  const [instagram, setInstagram] = useState('');
  const [facebook, setFacebook] = useState('');

  const previewLogo = appState?.adminDetails?.companyLogoUrl
  ? `${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${appState?.adminDetails?.companyLogoUrl}?width=480&height=480&optimize=image`
  : "/img/thumbnail/gallery/placeholder-image.jpg";

const previewIcon = appState?.adminDetails?.companyFaviconUrl
  ? `${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${appState.adminDetails.companyFaviconUrl}?width=64&height=64&optimize=image`
  : "/img/thumbnail/gallery/placeholder-image.jpg";

  
  useEffect(() => {
  if (appState?.adminDetails) {
    setCompanyName(appState.adminDetails.companyName || '');
    setPhone(appState.adminDetails.phone || '');
setAddress(appState.adminDetails.address || '');
    setWebsiteUrl(appState.adminDetails.websiteUrl || '');
    // You can also prefill social media links if available:
    setYoutube(appState.adminDetails.socialLinks?.youtube || '');
    setInstagram(appState.adminDetails.socialLinks?.instagram || '');
    setFacebook(appState.adminDetails.socialLinks?.facebook || '');
  }
}, [appState?.adminDetails]);


  const uploadFailed = async (file) => {
    alert("Oops Image Uploading Failed....");
  };

  const imgOnPrg = () => {
    console.log("Image uploading On Progress");
  };

const imgUploadedDone = async (file, type) => {
  
  const filePath = `${appState.adminDetails.id}/assets/${file.name}`;

  const obj = type === 'logo'
    ? { companyLogoUrl: filePath }
    : { companyFaviconUrl: filePath };

  const response = await putData(`admin/admin-update/${appState.adminDetails.id}`, { obj });

  if (response) {
    setAppState((prev) => ({
      ...prev,
      adminDetails: {
        ...prev.adminDetails,
        ...obj,
      },
    }));
    console.log("Upload successful:", obj);
    alert("Upload Successful")
  }
};


  const handleUpdate = async() => {

    
    // Update your company name, websiteUrl, and social links logic here
    console.log("Updated Values:", {
      companyName,
      phone,
      address,
      websiteUrl,
      youtube,
      instagram,
      facebook,
    });
    const obj =  {
      companyName,
      phone,
      address,
      websiteUrl,
      socialLinks:{
      youtube,
      instagram,
      facebook
    }
      
    }

    console.log(appState.adminDetails)

     
       const response = await putData(`admin/admin-update/${appState.adminDetails.id}`, {
          obj
                  });
         if(response)
         {
            setAppState((prev) => ({
      ...prev,
      adminDetails: {
        ...prev.adminDetails,
        ...obj,
      },
    }));
         }
    alert("Company details updated.");
  };
//src={`${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${appState.adminDetails.companyLogoUrl}?width=480&height=480&optimize=image`}
  const previewImage = appState?.adminDetails?.companyLogoUrl
    ? `${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${appState.adminDetails.companyLogoUrl}?width=480&height=480&optimize=image`
    : "../../../img/thumbnail/gallery/placeholder-image.jpg";

  return (
    <div className='flex w-full max-h-[calc(100vh-70px)] overflow-auto py-8 mb-16'>
      {/* Left Panel */}
      <div className='w-1/2 ml-6'>

        {/* Company Name */}
        <Card title="Company Name" description="As you want to appear on Client Galleries">
          {console.log("FFFFFFF ",companyName)}
          <InputField
            label="Enter Company or Brand Name"
            value={companyName}
            onChange={setCompanyName}
            placeholder="Enter Company or Brand Name"
          />
          <UpdateButton onClick={handleUpdate} />
        </Card>
      <Card title="Phone Number" description="Contact number for clients">
  <InputField
    label="Enter Phone Number"
    value={phone}
    onChange={setPhone}
    placeholder="+91 98765 43210"
  />
  <UpdateButton onClick={handleUpdate} />
        </Card>
        <Card title="Address" description="Company physical location">
  <InputField
    label="Enter Address"
    value={address}
    onChange={setAddress}
    placeholder="House No, Street, City, State"
  />
  <UpdateButton onClick={handleUpdate} />
</Card>
        {/* Image Uploads */}
        <div className='flex mt-4 bg-white shadow-lg rounded-lg'>
          {[1, 2].map((i) => (
            <div className='w-1/2 h-auto p-6' key={i}>
          <img
  className="py-4 object-contain h-[200px]"
  src={i === 1 ? previewLogo : previewIcon}
  alt="Selected Preview"
/>

              <div className="text-xs text-left text-gray-800 py-2">
                {i === 1 ? '500 * 500px or larger' : '32 * 32px or larger'}<br />
                PNG, JPG, or JPEG (up to {i === 1 ? '40MB' : '1MB'})
              </div>
              <UploadImageBg
                imgOnPrg={imgOnPrg}
                imgUploadedDone={(file) => imgUploadedDone(file, i === 1 ? 'logo' : 'icon')}
                uploadFailed={uploadFailed}
                txt={i === 1 ? "Upload Logo" : "Upload Icon"}
                baseUrl={`${appState.adminDetails.id}/assets`}
                 type={i === 1 ? 'logo' : 'icon'}
              />
            </div>
          ))}
        </div>

        {/* Website */}
        <Card title="Website" description="Your Website or Portfolio URL (include https://)">
          <InputField
            label="Enter Website URL"
            value={websiteUrl}
            onChange={setWebsiteUrl}
            placeholder="https://example.com"
          />
          <UpdateButton onClick={handleUpdate} />
        </Card>

        {/* Social Media */}
        <Card title="Social Media Profiles" description="URLs for your social media profiles (include https://)">
          <InputField
            label="YouTube"
            value={youtube}
            onChange={setYoutube}
            placeholder="https://youtube.com/@yourchannel"
          />
          <InputField
            label="Instagram"
            value={instagram}
            onChange={setInstagram}
            placeholder="https://instagram.com/yourprofile"
          />
          <InputField
            label="Facebook"
            value={facebook}
            onChange={setFacebook}
            placeholder="https://facebook.com/yourpage"
          />
          <UpdateButton onClick={handleUpdate} />
        </Card>
      </div>

      {/* Right Panel - Preview */}
      <div className='w-1/2 border p-4'>
        {/* <PreviewBox /> */}
      </div>
    </div>
  );
};

export default CompanySetting;

// Reusable Components
const InputField = ({ label, value, onChange, placeholder }) => (
  <div className="pt-2">
    <label className="block text-sm font-medium text-gray-700">{label}</label>
    <input
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm px-3 py-2 focus:ring-2 focus:ring-yellow-800 focus:outline-none"
    />
  </div>
);

const UpdateButton = ({ onClick }) => (
  <div className="pt-2">
    <button
      type="button"
      onClick={onClick}
      className="w-full bg-gray-800 text-white font-medium py-2 px-4 rounded-md hover:bg-gray-700 transition duration-200"
    >
      Update
    </button>
  </div>
);

const Card = ({ title, description, children }) => (
  <div className="max-w-md text-left bg-white shadow-lg rounded-xl mt-6 p-6">
    <div className="mb-4">
      <h2 className="text-xl font-semibold text-gray-800">{title}</h2>
      <p className="text-sm text-gray-500">{description}</p>
    </div>
    {children}
  </div>
);

const Circle = ({ color }) => (
  <div
    className="w-2.5 h-2.5 rounded-full mr-1.5"
    style={{ backgroundColor: color }}
  />
);

const PreviewBox = () => {
    const { value } = useContext(Context);
  const [appState, setAppState] = value;
  const linkStyle = {
    position: 'relative',
    width: '300px',
    height: '500px',
    minHeight: '520px',
    maxHeight: '613px',
    maxWidth: '100%',
    margin: 'auto',
    borderRadius: '15px',
    background: '#1a1a1a',
    border: '1px solid #161616',
    transition: 'all 0.3s ease-in-out',
  };

  const formatUrl = (url) => {
  if (!url) return '#';
  return url.startsWith('http') ? url : `https://${url}`;
};

  return (
    <div style={linkStyle}>
      <div style={{ display: 'flex', position: 'absolute', top: '2px', left: '12px', opacity: 0.4 }}>
        <Circle color="#ff605c" />
        <Circle color="#ffbd44" />
        <Circle color="#00ca4e" />
      </div>

      <div className="mx-auto mt-6 flex items-center justify-center">
        {/* Sample Preview */}
        <div className="bg-white shadow-lg rounded-lg w-[94%] h-[94%] py-12 max-w-md mx-auto studio-modal">
        <img
  src={`${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${appState?.adminDetails?.companyLogoUrl}?width=960&height=960&optimize=photo`}
  alt="Company Logo"
  className="w-32 h-32 rounded-full mx-auto mb-4 object-contain"
/>

          <p className="text-2xl font-semibold text-center mb-2">{appState?.adminDetails?.companyName}</p>
          <hr className="my-4" />

          <a
            href={formatUrl(appState?.adminDetails.websiteUrl)}
            target="_blank"
            rel="noopener noreferrer"
            className="block text-blue-600 hover:text-blue-800 text-center font-medium"
          >
            VISIT WEBSITE
          </a>

          <hr className="my-4" />

          <div>
            <p className="text-center font-medium text-gray-700">FOLLOW US</p>
            <ul className="flex justify-center gap-4 mt-4">

        {Object.entries(appState?.adminDetails?.socialLinks || {})
  .filter(([_, url]) => url.trim() !== "")
  .map(([social, url], i) => {
    // Agar url 'http' ya 'https' se start nahi hota, toh https:// add karo
    const finalUrl = url.startsWith("http://") || url.startsWith("https://")
      ? url
      : `https://${url}`;

    return (
      <li key={i}>
        <a
          href={finalUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={`text-${social}-500 hover:bg-${social}-100 p-2 rounded-full border border-${social}-500`}
        >
          <i className={`fab fa-${social}`}></i>
        </a>
      </li>
    );
  })}


              
            </ul>
          </div>

          <hr className="my-4" />

          <div className="flex items-center justify-center ">
            <p className="text-sm">made with</p>
            <a href="https://vidmantra.com" target="_blank" rel="noopener noreferrer" className="font-semibold text-sm">
            VidMantra
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
